import { useEffect, useState, useRef } from "react";
import { useNavigate, useParams, generatePath } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import BottomBarIcons from "./BottomBarIcons";
import useGetClientId from "../hooks/useGetClientId";
// import Select from "react-select";
import {
  GET_ALL_PROPERTY_AND_ROLE_BASED_ON_CLIENT_ID,
  INVITE_MEMEBER_AND_ASSIGN_PROPERTY_V2,
} from "../api/apiPath";
import http from "../api/server";
import Toaster from "./common/Toaster";
import useGetCity from "../hooks/useGetCity";
import PhoneNumber from "./common/PhoneNumber";
import SidebarIcons from "./SidebarIcons";
import AutocompleteInput from "./common/AutocompleteInput";
const InviteNewMember = () => {
  const { clientNameParam } = useParams();
  const [hideSidebar, setHideSidebar] = useState(false);
  const [userObj, setUserObj] = useState({});
  // const [allProperty, setAllProperty] = useState(null);
  const [allRoles, setAllRoles] = useState(null);
  const [city, setCity] = useState(null);
  const clientObj = useGetClientId();
  const [isMemberInvited, setIsMemberInvited] = useState(true);
  const cityObj = useGetCity();
  const [validationFlag, setValidationFlag] = useState(false);
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  useEffect(() => {
    setCity(cityObj?.cityList);
  }, [cityObj.cityList, cityObj.loading]);
  // console.log(cityObj);
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };
  // console.log("dataObj", dataObj);

  const navigate = useNavigate();
  useEffect(() => {
    setUserObj({ name: "Test User" });
  }, []);
  const handleGetAllPropertyByClinetID = async (clientId) => {
    try {
      const response = await http.get(
        GET_ALL_PROPERTY_AND_ROLE_BASED_ON_CLIENT_ID + "?clientId=" + clientId
      );
      if (response.status === 200) {
        // const extractedPropertyData = response.data.properties?.map((item) => ({
        //   value: item.propertyId,
        //   label: item.propertyName,
        // }));
        // setAllProperty(extractedPropertyData);
        // setAllRoles(response.data.roles);
        const sortedRoles = [...(response.data.roles || [])].sort((a, b) =>
  (a.roleName || "").localeCompare(b.roleName || "", undefined, {
    sensitivity: "base",
  })
);

setAllRoles(sortedRoles);

        // console.log("propertname", response.data.properties);
        console.log("role", response.data.roles);
      }
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (clientObj.clientId) {
      handleGetAllPropertyByClinetID(clientObj.clientId);
    }
  }, [clientObj.clientId, clientObj.loading]);

  const [entries, setEntries] = useState([
    {
      id: 1,
      email: "",
      role: "",
      // propertyName: "",
      firstName: "",
      lastName: "",
      phoneNumber: "",
      city: "",
      userType: "",
      status: "active",
    }, // Initial entry
  ]);

  const addEntry = () => {
    const newId =
      entries.length > 0 ? Math.max(...entries.map((e) => e.id)) + 1 : 1;
    setEntries([
      ...entries,
      {
        id: newId,
        email: "",
        role: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        userType: "",
        status: "active",
        city: "",
        // propertyName: "",
      },
    ]);
  };

  const removeEntry = (id) => {
    setEntries(entries?.filter((entry) => entry.id !== id));
  };

  const isValidEmailOrMobile = (value) => {
    // Email regex
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //.com or .in    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const additionalemailRegex = /^[^\s@]+@[^\s@]+\.(com|in|co\.in|co\.uk)$/;
    const valid = additionalemailRegex.test(value);
    return valid;
  };

  const handleChange = (id, field, value) => {
    if (field === "phoneNumber") {
      console.log("value", value);
      const rawNumber = value?.mobileNumber
        .replace(value?.mobileDialCode, "")
        .replace(/^\+/, "");
      const formattedNumber = `+${value?.mobileDialCode}-${rawNumber}` || "";
      setEntries(
        entries?.map((entry) =>
          entry.id === id ? { ...entry, [field]: formattedNumber } : entry
        )
      );
      console.log("formattedNumber", formattedNumber);
    } else {
      setEntries(
        entries?.map((entry) =>
          entry.id === id ? { ...entry, [field]: value } : entry
        )
      );
    }
  };

  const firstNameRef = useRef({});
  const lastNameRef = useRef({});
  const emailRef = useRef({});
  const phoneRef = useRef({});
  const typeRef = useRef({});
  const cityRef = useRef({});
  const roleRef = useRef({});

  const handleSave = (event) => {
    event.preventDefault();
    console.log(entries);
    let isValid = true;
    setValidationFlag(false);
    entries.forEach((entry) => {
      const fRef = firstNameRef.current[entry.id];
      if (!(entry.firstName ?? "").trim()) {
        if (fRef) {
          fRef.style.border = "1px solid red";
          fRef.classList.add("input-error");
        }
        isValid = false;
      } else {
        if (fRef) {
          fRef.style.border = "1px solid #ced4da";
          fRef.classList.remove("input-error");
        }
      }

      const lRef = lastNameRef.current[entry.id];
      if (!(entry.lastName ?? "").trim()) {
        if (lRef) {
          lRef.style.border = "1px solid red";
          lRef.classList.add("input-error");
        }
        isValid = false;
      } else {
        if (lRef) {
          lRef.style.border = "1px solid #ced4da";
          lRef.classList.remove("input-error");
        }
      }

      const eRef = emailRef.current[entry.id];
      if (!(entry.email ?? "").trim() || !isValidEmailOrMobile(entry.email)) {
        if (eRef) {
          eRef.style.border = "1px solid red";
          eRef.classList.add("input-error");
        }
        isValid = false;
      } else {
        if (eRef) {
          eRef.style.border = "1px solid #ced4da";
          eRef.classList.remove("input-error");
        }
      }

      // const input = phoneRef.current[entry.id];
      // if (input) {
      //   if (!entry.phoneNumber) {
      //     input.parentNode.style.border = "1px solid red";
      //   } else {
      //     input.parentNode.style.border = "1px solid #ced4da";
      //   }
      // }

      const tRef = typeRef.current[entry.id];
      if (!(entry.userType ?? "").trim()) {
        if (tRef) {
          tRef.style.border = "1px solid red";
          tRef.classList.add("input-error");
        }
        isValid = false;
      } else {
        if (tRef) {
          tRef.style.border = "1px solid #ced4da";
          tRef.classList.remove("input-error");
        }
      }

      // const cRef = cityRef.current[entry.id];
      // if (!(entry.city ?? "").trim()) {
      //   if (cRef) cRef.style.border = "1px solid red";
      //   isValid = false;
      // } else {
      //   if (cRef) cRef.style.border = "1px solid #ced4da";
      // }
      const cRef = cityRef.current[entry.id];
      if (!entry.city) {
        if (cRef) {
          // inputRef in AutocompleteInput points directly to the input element
          cRef.style.border = "1px solid red";
          cRef.classList.add("input-error");
        }
        isValid = false;
      } else {
        if (cRef) {
          cRef.style.border = "1px solid #ced4da";
          cRef.classList.remove("input-error");
        }
      }

      const rRef = roleRef.current[entry.id];
      if (!(entry.role ?? "").trim()) {
        if (rRef) {
          rRef.style.border = "1px solid red";
          rRef.classList.add("input-error");
        }
        isValid = false;
      } else {
        if (rRef) {
          rRef.style.border = "1px solid #ced4da";
          rRef.classList.remove("input-error");
        }
      }
    });

    if (!isValid) {
      setValidationFlag(true);
      return;
    }
    handleInviteUser();
  };

  const handleInviteUser = async () => {
    console.log(entries);
    const payload = entries?.map((item) => ({
      clientId: clientObj.clientId,
      //propertyId: item?.propertyName?.value,
      roleId: item.role,
      userEmail: item.email,
      firstName: item.firstName,
      lastName: item.lastName,
      phoneNumber: item.phoneNumber,
      userType: item.userType,
      cityId: item.city,
      userStatus: item.status,
      userId: 0,
    }));
    const finalPayload = {
      assignments: payload,
      isMemberInvited: isMemberInvited,
    };

    try {
      const response = await http.post(
        INVITE_MEMEBER_AND_ASSIGN_PROPERTY_V2,
        finalPayload
      );

      if (response.status === 200) {
        const result = response?.data.results;
        if (result && result.length > 0 && result[0]?.status !== "Error") {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Members are successfully invited",
          });
          setEntries([
            {
              id: 1,
              email: "",
              role: "",
              propertyName: "",
              firstName: "",
              lastName: "",
              phoneNumber: "",
              userType: "",
              status: "active",
              city: "",
            }, // Initial entry
          ]);
        } else {
          const message = result[0]?.message || "Failed to invite members";
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: message,
          });
        }
      }

      if (!response.status) {
        setIsMemberInvited(false);
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
    } catch (error) {
      if (error.status === 400) {
        setIsMemberInvited(false);
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: error?.data?.title,
        });
      }
    }
  };
  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      {userObj && (
        <div className="dashboard_body_main">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}
          {/* <Sidebar
            isCollapsed={hideSidebar}
            onToggle={() => setHideSidebar((v) => !v)}
          /> */}
          <div className="d-flex dashboard_body flex-column py-1 w-100 mt-2">
            <div className="dashboard_header">
              <h2 className="mb-0">Invite New Member</h2>
              <div className="d-flex flex-row justify-content-between">
                <p className="header-description">Invite a new member</p>
              </div>
            </div>

            <div >
              {entries?.map((entry, index) => (
                // eslint-disable-next-line react/jsx-key,
                <>
                  <div className="resident-card d-flex flex-column gap-2 mt-3 text-start">
                    <div
                      className="card-body-section"
                    >
                      <div className="form-group">
                        <label
                          htmlFor="firstname"
                          // className="form-label text-start d-block fw-semibold"
                        >
                          First Name <span className="label-star">*</span>
                        </label>
                        <input
                          type="text"
                          maxLength="50"
                          // className="form-control"
                          id="firstname"
                          required
                          placeholder="First Name"
                          value={entry.firstName}
                          ref={(el) => (firstNameRef.current[entry.id] = el)}
                          onChange={(e) => {
                            handleChange(entry.id, "firstName", e.target.value);
                            // Clear error on change
                            if (firstNameRef.current[entry.id]) {
                              firstNameRef.current[entry.id].style.border = "1px solid #ced4da";
                              firstNameRef.current[entry.id].classList.remove("input-error");
                            }
                          }}
                        />
                      </div>

                      <div className="form-group">
                        <label
                          htmlFor="firstname"
                          // className="form-label text-start d-block fw-semibold"
                        >
                          Last Name <span className="label-star">*</span>
                        </label>
                        <input
                          type="lastname"
                          maxLength="50"
                          // className="form-control"
                          id="floatingInput"
                          placeholder="Last Name"
                          required
                          value={entry.lastName}
                          ref={(el) => (lastNameRef.current[entry.id] = el)}
                          onChange={(e) => {
                            handleChange(entry.id, "lastName", e.target.value);
                            // Clear error on change
                            if (lastNameRef.current[entry.id]) {
                              lastNameRef.current[entry.id].style.border = "1px solid #ced4da";
                              lastNameRef.current[entry.id].classList.remove("input-error");
                            }
                          }}
                        />
                      </div>
                      <div className="form-group">
                        <label
                          htmlFor="firstname"
                          // className="form-label text-start d-block fw-semibold"
                        >
                          Email <span className="label-star">*</span>
                        </label>
                        <input
                          type="email"
                          // className="form-control"
                          id="floatingInput"
                          placeholder="Enter email address"
                          value={entry.email}
                          ref={(el) => (emailRef.current[entry.id] = el)}
                          onChange={(e) => {
                            handleChange(entry.id, "email", e.target.value);
                            // Clear error on change
                            if (emailRef.current[entry.id]) {
                              emailRef.current[entry.id].style.border = "1px solid #ced4da";
                              emailRef.current[entry.id].classList.remove("input-error");
                            }
                          }}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label
                          htmlFor="firstname"
                          // className="form-label text-start d-block fw-semibold"
                        >
                          Contact Number{" "}
                        </label>
                        <PhoneNumber
                          setPhoneNumber={(e) => {
                            handleChange(entry.id, "phoneNumber", e);
                          }}
                          phoneNumber={{
                            mobileNumber: entry.phoneNumber,
                            mobileCountryCode: "",
                            mobileDialCode: "",
                          }}
                          inputRef={(el) => (phoneRef.current[entry.id] = el)}
                        />
                      </div>

                      <div className="form-group ">
                        <label htmlFor={`userType-${entry.id}`}>
                          Type <span className="label-star">*</span>
                        </label>
                        <select                       
                          name="userType"
                          className={`form-select ${validationFlag && !(entry.userType ?? "").trim() ? "input-error" : ""}`}
                          id={`userType-${entry.id}`}
                          aria-label="Floating label select example"
                          value={entry.userType} // <-- binds to state
                          ref={(el) => (typeRef.current[entry.id] = el)}
                          onChange={(e) => {
                            handleChange(entry.id, "userType", e.target.value);
                            // Clear error on change
                            if (typeRef.current[entry.id]) {
                              typeRef.current[entry.id].style.border = "1px solid #ced4da";
                              typeRef.current[entry.id].classList.remove("input-error");
                            }
                          }}
                        >
                          <option value="">Select Type</option>
                          <option value="Contractor">Contractor</option>
                          <option value="Internal Staff">Internal Staff</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor={`city-${entry.id}`}>
                          City <span className="label-star">*</span>
                        </label>
                        <AutocompleteInput
                          // masterList={city || []}
                            masterList={
                              [...(city || [])].sort((a, b) =>
                                (a.cityName || "").localeCompare(b.cityName || "", undefined, {
                                  sensitivity: "base",
                                })
                              )
                            }
                          className="form-select"
                          getOptionLabel={(c) => c?.cityName || ""}
                          getOptionValue={(c) => c?.cityId || ""}
                          value={entry.city}
                          onValueChange={(val) => {
                            handleChange(entry.id, "city", val);
                            // Clear error on change
                            const cRef = cityRef.current[entry.id];
                            if (cRef) {
                              // inputRef in AutocompleteInput points directly to the input element
                              cRef.style.border = "1px solid #ced4da";
                              cRef.classList.remove("input-error");
                            }
                          }}
                          placeholder="Select City"
                          inputClassName=""
                          wrapperClassName=""
                          notFoundText="City not found"
                          inputId={`city-${entry.id}`}
                          inputRef={(el) => (cityRef.current[entry.id] = el)}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={`role-${entry.id}`}>
                          Role <span className="label-star">*</span>
                        </label>
                        <select
                          name="role"
                          className={`form-select ${validationFlag && !(entry.role ?? "").trim() ? "input-error" : ""}`}
                          id={`role-${entry.id}`}
                          aria-label="Floating label select example"
                          value={entry.role}
                          ref={(el) => (roleRef.current[entry.id] = el)}
                          onChange={(e) => {
                            handleChange(entry.id, "role", e.target.value);
                            // Clear error on change
                            if (roleRef.current[entry.id]) {
                              roleRef.current[entry.id].style.border = "1px solid #ced4da";
                              roleRef.current[entry.id].classList.remove("input-error");
                            }
                          }}
                        >
                          <option value="">Select a Role</option>
                          {allRoles?.map((data) => (
                            <option key={data?.roleId} value={data?.roleId}>
                              {data.roleName}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="floatingSelect">
                          Status <span className="label-star">*</span>
                        </label>
                        <select
                          name="role"
                          className="form-select"
                          id="floatingSelect"
                          aria-label="Floating label select example"
                          value={entry.status}
                          onChange={(e) =>
                            handleChange(entry.id, "status", e.target.value)
                          }
                        >
                          <option value="active">Active</option>
                          <option value="archived">Archived</option>
                        </select>
                      </div>
                    </div>
                    <div
                    className="col-sm-12 col-auto gap-3"
                    style={{ textAlign: "end" }}
                  >
                    <button
                      type="button"
                      className={`btn btn-light rounded ${
                        !(entries.length - 1 === index) ? "displayNone" : ""
                      }`}
                      style={{
                        fontSize: "12px",
                        background: "white",
                        color: "#212121",
                      }}
                      onClick={addEntry}
                      disabled={
                        entries.length === 0
                          ? false
                          : !(entries.length - 1 === index)
                      }
                    >
                      <i className="fa-solid fa-plus icon_rounded"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-light rounded"
                      style={{
                        fontSize: "12px",
                        background: "white",
                        color: "#212121",
                      }}
                      onClick={() => removeEntry(entry.id)}
                      disabled={entries.length === 1 ? true : false}
                    >
                      <i className="fa-solid fa-minus icon_rounded"></i>
                    </button>
                  </div>
                  </div>
                  
                </>
              ))}
            </div>
            <div className="button-container">
              
              <button
                  type="submit"
                  className="btn-primary col-sm-5 col-md-2"
                  onClick={handleSave}
                >
                  Save Member
                </button>
              
                <button
                  type="button"
                  className="btn-secondary col-sm-5 col-md-2"
                  onClick={() => {
                    navigate(
                      generatePath("/client/:clientNameParam/members", {
                        clientNameParam,
                      })
                    );
                  }}
                >
                  Cancel
                </button>
                <div>
                {" "}
                {validationFlag && (
                  <small style={{ color: "red" }} className=" mb-1">
                    * Please fill all required fields with valid details
                  </small>
                )}
              </div>
                
             
            </div>

            <Toaster
              show={toastData.toastShow}
              toastType={toastData.toastType}
              title={toastData.toastString}
              theme={"dark"}
              position="top-center"
              closeButton={() => {
                closeButton();
              }}
            />
          </div>
          <Footer />
          <div className="bottom-bar-spacing"></div>
          <BottomBarIcons />
        </div>
      )}
    </>
  );
};

export default InviteNewMember;
